var _quizEditorDismissed = false;

class QuizIntent extends HTMLElement {
  connectedCallback() {
    this.storageKey = 'lmdb_quiz_done';
    this.discountCode = this.dataset.discountCode || 'MAISON5';
    this.delay = parseInt(this.dataset.delay || '4', 10) * 1000;
    this.klaviyoListId = this.dataset.klaviyoListId || '';
    this.klaviyoPublicKey = this.dataset.klaviyoPublicKey || '';
    this.selectedChoice = null;

    var isEditor = !!(window.Shopify && window.Shopify.designMode);
    var isPreview = new URLSearchParams(location.search).get('quiz') === '1';
    var bypass = isEditor || isPreview;

    if (isEditor && _quizEditorDismissed) return;
    if (isPreview) sessionStorage.removeItem(this.storageKey);
    if (!bypass && sessionStorage.getItem(this.storageKey)) { this.remove(); return; }

    this._isEditor = isEditor;
    this._overlay = this.querySelector('[data-ref="overlay"]');
    this._step1 = this.querySelector('[data-ref="step1"]');
    this._step2 = this.querySelector('[data-ref="step2"]');
    this._step3 = this.querySelector('[data-ref="step3"]');
    this._codeEl = this.querySelector('[data-ref="code"]');
    this._emailInput = this.querySelector('[data-ref="email"]');

    this._bindEvents();

    var self = this;
    setTimeout(function() {
      self._overlay.style.display = 'flex';
      document.body.style.overflow = 'hidden';
    }, bypass ? 0 : this.delay);
  }

  _bindEvents() {
    var self = this;
    this.querySelectorAll('[data-role="choice"]').forEach(function(btn) {
      btn.addEventListener('click', function() { self._handleChoice(btn.dataset.value); });
    });
    this.querySelectorAll('[data-role="close"]').forEach(function(btn) {
      btn.addEventListener('click', function(e) { e.stopPropagation(); self._close(); });
    });
    var skipBtn = this.querySelector('[data-role="skip"]');
    if (skipBtn) skipBtn.addEventListener('click', function() { self._close(); });
    var emailSubmit = this.querySelector('[data-role="email-submit"]');
    if (emailSubmit) emailSubmit.addEventListener('click', function() { self._handleEmail(); });
    var emailSkip = this.querySelector('[data-role="email-skip"]');
    if (emailSkip) emailSkip.addEventListener('click', function() { self._applyAndShow(); });
    if (this._emailInput) {
      this._emailInput.addEventListener('keydown', function(e) { if (e.key === 'Enter') self._handleEmail(); });
    }
    var copyBtn = this.querySelector('[data-role="copy"]');
    if (copyBtn) copyBtn.addEventListener('click', function() { self._copyCode(); });
  }

  _handleChoice(value) {
    this.selectedChoice = value;
    sessionStorage.setItem(this.storageKey, value);
    this._step1.style.display = 'none';
    this._step2.style.display = 'block';
  }

  _handleEmail() {
    var email = this._emailInput ? this._emailInput.value.trim() : '';
    if (!email || email.indexOf('@') === -1) {
      if (this._emailInput) this._emailInput.classList.add('quiz-intent__input--error');
      return;
    }
    if (this._emailInput) this._emailInput.classList.remove('quiz-intent__input--error');
    this._subscribeKlaviyo(email);
    this._applyAndShow();
  }

  _subscribeKlaviyo(email) {
    var self = this;
    var companyId = this.klaviyoPublicKey;
    var listId = this.klaviyoListId;
    if (!companyId) return;

    if (listId) {
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + companyId, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2023-02-22' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              list_id: listId,
              email: email,
              custom_source: 'Quiz Popup - ' + self.selectedChoice
            }
          }
        })
      }).catch(function() {});
    }

    fetch('https://a.klaviyo.com/client/events/?company_id=' + companyId, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2023-02-22' },
      body: JSON.stringify({
        data: {
          type: 'event',
          attributes: {
            properties: {
              choice: self.selectedChoice,
              discount_code: self.discountCode
            },
            metric: {
              data: {
                type: 'metric',
                attributes: { name: 'Quiz Intent' }
              }
            },
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  properties: { quiz_choice: self.selectedChoice }
                }
              }
            }
          }
        }
      })
    }).catch(function() {});
  }

  _applyAndShow() {
    var iframe = document.createElement('iframe');
    iframe.style.cssText = 'position:absolute;width:0;height:0;border:0;visibility:hidden;';
    iframe.src = '/discount/' + this.discountCode;
    document.body.appendChild(iframe);
    setTimeout(function() { iframe.remove(); }, 5000);
    this._step2.style.display = 'none';
    this._step3.style.display = 'block';
    if (this._codeEl) this._codeEl.textContent = this.discountCode;
  }

  _copyCode() {
    var self = this;
    if (navigator.clipboard) {
      navigator.clipboard.writeText(this.discountCode).then(function() {
        var btn = self.querySelector('[data-role="copy"]');
        if (btn) { btn.textContent = 'Copie ✓'; setTimeout(function() { btn.textContent = 'Copier'; }, 2000); }
      });
    }
  }

  _close() {
    if (this._isEditor) {
      _quizEditorDismissed = true;
    } else {
      sessionStorage.setItem(this.storageKey, 'skipped');
    }
    this._overlay.style.display = 'none';
    document.body.style.overflow = '';
  }
}

if (!customElements.get('quiz-intent')) customElements.define('quiz-intent', QuizIntent);